import { Link } from "react-router-dom";

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  actionTo?: string;
  onAction?: () => void;
}

export default function EmptyState({
  icon = "ri-inbox-line",
  title,
  description,
  actionLabel,
  actionTo,
  onAction,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100/60 px-6 py-16 text-center">
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-background-200 text-foreground-500">
        <i className={`${icon} text-2xl`} />
      </div>
      <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">{title}</h3>
      {description ? (
        <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-500">{description}</p>
      ) : null}
      {actionLabel ? (
        actionTo ? (
          <Link
            to={actionTo}
            className="mt-6 inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-900 px-4 py-2 text-xs font-medium text-background-50 transition-colors duration-300 hover:bg-primary-800"
          >
            {actionLabel}
            <i className="ri-arrow-right-line" />
          </Link>
        ) : (
          <button
            type="button"
            onClick={onAction}
            className="mt-6 inline-flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-md bg-primary-900 px-4 py-2 text-xs font-medium text-background-50 transition-colors duration-300 hover:bg-primary-800"
          >
            {actionLabel}
            <i className="ri-refresh-line" />
          </button>
        )
      ) : null}
    </div>
  );
}